const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  SPEED_SWIM,
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ABILITY_CHARGE,
  ABILITY_WATER_BREATHING,
} = require('./../../../../creatureAbilityList')
const {
  CREATURE_GIANT_SEA_HORSE,
  CREATURE_SEA_HORSE,
} = require('./../../../../creatureIdList')
const {ALIGNMENT_NO} = require('./../../../../aligmentList')
const {ARMOR_TYPE_NATURAL} = require('./../../../../armorTypeList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {CR_1_2} = require('./../../../../crList')
const {CREATURE_TYPE_BEAST} = require('./../../../../creatureTypeIdList')
const {DAMAGE_BLUDGEONING} = require('./../../../../damageTypeList')
const {GENDER_MALE} = require('./../../../../genderList')
const {SIZE_LARGE} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')

module.exports = {
  name: 'Гигантский морской конёк',
  nameEn: 'Giant Sea Horse',
  id: CREATURE_GIANT_SEA_HORSE,
  description: `Так же, как и их [младшие родственники](CREATURE:${CREATURE_SEA_HORSE}), гигантские морские коньки — это тихие разноцветные рыбы с длинными телами и изогнутыми хвостами. Водные эльфы тренируют из них скакунов.`,
  sizeType: SIZE_LARGE,
  creatureTypeIdList: [
    CREATURE_TYPE_BEAST,
  ],
  alignmentId: ALIGNMENT_NO,
  source: {
    id: SOURCE_MM,
    page: 326,
  },
  armor: {
    ac: 13,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 3,
  },
  speed: {
    [SPEED_WALK]: 0,
    [SPEED_SWIM]: 40,
  },
  params: {
    [PARAM_STR]: 12,
    [PARAM_DEX]: 15,
    [PARAM_CON]: 11,
    [PARAM_INT]: 2,
    [PARAM_WIT]: 12,
    [PARAM_CHA]: 5,
  },
  cr: CR_1_2,
  featureList: [
    {
      id: ABILITY_CHARGE,
      range: 20,
      attackName: 'Тараном',
      damageText: '7 (2к6) дробящего урона',
      afterEffectText: 'Если цель — существо, она должна преуспеть в испытании Силы СЛ 11, иначе будет сбита с ног.',
    },
    ABILITY_WATER_BREATHING,
  ],
  actionList: [
    {
      name: 'Таран',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 3,
        range: 5,
        hit: {
          type: DAMAGE_BLUDGEONING,
          diceCount: 1,
          diceType: 6,
          diceBonus: 1,
        },
      },
    },
  ],
  genderId: GENDER_MALE,
}
